import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  showMetadataSwitch: {
    marginRight: 0,
    color: theme.palette.text.disabled,
  },
}));
